import { useEffect, useRef } from "react";
import { TAREFAS_AUTO_REFRESH_MS } from "@/config/constants";

type LoadFn = (opts?: { silent?: boolean }) => void | Promise<void>;

/**
 * Recarrega chamados TI em segundo plano para refletir novos tickets e mudanças de status
 * feitas por outros usuários, sem exigir clique em «Atualizar».
 */
export function useChamadosAutoRefresh(load: LoadFn, paused = false): void {
  const loadRef = useRef(load);
  loadRef.current = load;
  const pausedRef = useRef(paused);
  pausedRef.current = paused;

  useEffect(() => {
    const tick = () => {
      if (pausedRef.current) return;
      void loadRef.current({ silent: true });
    };

    const intervalId = window.setInterval(tick, TAREFAS_AUTO_REFRESH_MS);

    const onVisibility = () => {
      if (document.visibilityState === "visible") tick();
    };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);
}
